// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a68befef","239":"8096e25a","453":"04d9c6de","667":"9037a450"}[chunkId] + ".chunk.js";
};